import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    CarrierDropReason
} from '../../models/models';

@Component({
    selector: 'carrier-drop-reason-form',
    templateUrl: './carrier-drop-reason-form.component.html',
    standalone: false
})
export class CarrierDropReasonForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: CarrierDropReason = {} as CarrierDropReason;

    constructor(private cseService: CSEService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.cseService.getCarrierDropReasonByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                carrierDropReasonID: 0,
                abbreviation: "",
                description: "",
                chargeable: false            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.cseService.saveCarrierDropReason(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as CarrierDropReason;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}